import React, { Component } from 'react'
import Modal from './components/Modal'
import Button from './components/Button'

class EditUser extends Component {
  constructor (props) {
    super(props)

    this.state = props.data
      ? {
          passcode: props.data.passcode,
          quota: props.data.quota
        }
      : {}
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.data && this.props.data) {
      this.setState({ passcode: this.props.data.passcode, quota: this.props.data.quota })
    }
    if (prevProps.data && this.props.data && prevProps.data.id !== this.props.data.id) {
      this.setState({ passcode: this.props.data.passcode, quota: this.props.data.quota })
    }
  }

  randomPasscode = () => {
    let passcode = ''
    const possible = '0123456789'
    for (let i = 0; i < 8; i++) {
      passcode += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    this.setState({ passcode })
  }

  render () {
    if (!this.props.data) {
      return null
    }

    return (
      <Modal
        open
        onClose={this.props.onClose}
        title={`Edit ${this.props.data.user}`}
        footer={[
          <Button key='cancel' variant='ghost' onClick={this.props.onClose}>Cancel</Button>,
          <Button key='save' onClick={() => this.props.onSave(this.state, this.props.data)}>
            Save
          </Button>
        ]}
      >
        <div className='space-y-6'>
          <label className='block text-sm font-medium text-slate-700'>
            Passcode
            <div className='mt-2 flex rounded-xl border border-slate-200'>
              <input
                type='text'
                className='flex-1 border-0 px-3 py-2 rounded-l-xl focus:outline-none'
                value={this.state.passcode || ''}
                onChange={e => this.setState({ passcode: e.target.value })}
              />
              <button
                type='button'
                className='px-3 text-sm font-semibold text-blue-600 border-l border-slate-200 rounded-r-xl hover:bg-slate-50'
                onClick={this.randomPasscode}
              >
                Refresh
              </button>
            </div>
          </label>

          <div className='space-y-2'>
            <label className='inline-flex items-center gap-2 text-sm text-slate-700'>
              <input
                type='checkbox'
                className='w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500'
                checked={this.state.quota !== null}
                onChange={e =>
                  this.setState({
                    quota: e.target.checked ? this.props.company.defaultQuotaPerUser : null
                  })
                }
              />
              Set independent device quota
            </label>
            {this.state.quota !== null && (
              <input
                type='number'
                className='w-full rounded-xl border border-slate-200 px-3 py-2 focus:border-ink focus:ring-1 focus:ring-ink max-w-xs'
                value={this.state.quota}
                onChange={e => this.setState({ quota: Number(e.target.value) || 0 })}
              />
            )}
          </div>
        </div>
      </Modal>
    )
  }
}

export default EditUser
